exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".surveys .column-header {\n  border-top: 2px solid #e3f0f4;\n  padding: 0.5rem 1rem;\n  color: #7091c5; }\n\n.surveys .survey {\n  padding: 0.75rem 1rem;\n  border-top: 2px solid #e3f0f4; }\n  .surveys .survey .item-actions {\n    opacity: 0;\n    transition: all 200ms ease-in; }\n  .surveys .survey:hover {\n    cursor: pointer; }\n    .surveys .survey:hover .item-actions {\n      opacity: 1; }\n  .surveys .survey:hover {\n    background-color: #fcf9f3; }\n  .surveys .survey .name {\n    font-weight: bold; }\n  .surveys .survey .content {\n    color: #898a8e;\n    margin-bottom: 1rem; }\n  .surveys .survey .access-level {\n    color: #898a8e;\n    text-align: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/surveys/surveys-list/surveys-list.component.scss
// module id = 417
// module chunks = 0